import { use } from 'react';
import { useTranslation } from 'react-i18next';
import SearchOffRoundedIcon from '@mui/icons-material/SearchOffRounded';
import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import Divider from 'shared/components/divider/divider';
import LoadingIndicator from 'shared/components/loading-indicator/loading-indicator';
import ViewingMode from 'shared/components/viewing-mode-controller/types/viewing-mode';

import { ElectronicClientRecordLocationResultOption } from 'features/organisation/views/organisation-details/components/electronic-client-record/components/link-room-modal/domain/enums/electronic-client-record-location-result-option';
import LinkRoomModal from './components/link-room-modal/link-room-modal';
import LinkedRoomItem from './components/linked-room-item/linked-room-item';
import ElectronicClientRecordProviderContext from './providers/contexts/electronic-client-record-context';
import styles from './electronic-client-record.module.scss';

type Props = {
  viewingMode: ViewingMode;
};

const ElectronicClientRecord = ({ viewingMode }: Props): React.JSX.Element => {
  const { t } = useTranslation('organisation', { keyPrefix: 'electronicClientRecord' });

  const { watchedSelectedRoom, isLoading } = use(ElectronicClientRecordProviderContext);

  return (
    <>
      <Divider
        className="organisation-units-details-divider"
        startText={t('dividerText')}
        endElement={viewingMode === 'creation' || viewingMode === 'editing' ? <LinkRoomModal /> : <></>}
      />

      {watchedSelectedRoom?.result === ElectronicClientRecordLocationResultOption.Failed && (
        <Alert icon={<SearchOffRoundedIcon className={styles.ecdWarningIcon} />} className={styles.ecdWarning}>
          {t('roomNoLongerExists')}
        </Alert>
      )}

      {watchedSelectedRoom?.id ? (
        <>{isLoading ? <LoadingIndicator /> : <LinkedRoomItem viewingMode={viewingMode} />}</>
      ) : (
        <Typography variant="subtitle1">{t('noElectronicClientRecordRoomLinked')}</Typography>
      )}
    </>
  );
};

export default ElectronicClientRecord;
